var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirtualBrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.09,51.92v124s-42,10.8-42-23.38c-17.84.21-26.43-29.34-5.28-41.25,0,0-11.68-37.5,11.45-42.13,0,0,11.89-1.54,11.89-12.57S97.29,39.56,103.09,51.92ZM79.38,111H57.13M103,134.42H78.5L67.05,122.73M61.1,152.51H78.71l6.18,5.74m17-77.07H78.58L72.64,88M159,154.93l-8.73,21H115V45.28h16.87l4,12.15h14.64l12.92,35.4h12v61.66Zm-17.15-46.32H175m-59.86,25.81h35.54M115.42,81.18H136m12.82,0A6.11,6.11,0,1,1,142.71,75,6.11,6.11,0,0,1,148.82,81.16Zm14.78,52.69a6.12,6.12,0,1,1-6.11-6.12A6.11,6.11,0,0,1,163.6,133.85Zm-28.33,1.27v14.69m.57,12.95a6.13,6.13,0,1,1,6.11-6.12A6.11,6.11,0,0,1,135.84,162.76Zm5.74-54.32a6.12,6.12,0,1,1-6.12-6.13A6.13,6.13,0,0,1,141.58,108.44Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualBrain);
export default __webpack_public_path__ + "static/media/VIRTUAL_BRAIN.448dfc6e45b4582e93f4a984418342dc.svg";
export { ForwardRef as ReactComponent };